
import Vue from 'vue';
import Vuex from 'vuex';
import wheelStore from './wheelStore.js';
import preferencesStore from './preferencesStore.js';
import riggingStore from './riggingStore.js';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    wheel: wheelStore,
    preferences: preferencesStore,
    rigging: riggingStore
  }
})
